(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};

  window.SPCLST.modules.hero = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;
    var on = helpers.on;
    var parseBool = helpers.parseBool;
    var isMobileViewport = helpers.isMobileViewport;
    var isDesktopNavViewport = helpers.isDesktopNavViewport;

    queryAll('[data-spclst-hero-video-wrap]').forEach(function (heroWrap) {
      var video = query('[data-spclst-hero-video]', heroWrap);
      if (!video) return;

      var playToggle = query('[data-spclst-hero-play-toggle]', heroWrap);
      var soundToggle = query('[data-spclst-hero-sound-toggle]', heroWrap);
      var playIcon = query('[data-spclst-hero-play-icon]', heroWrap);
      var soundIcon = query('[data-spclst-hero-sound-icon]', heroWrap);
      var posterFallback = query('[data-spclst-hero-poster]', heroWrap);
      var fallbackTimer = null;

      function isVideoVisiblyPlaying() {
        return video.readyState >= 2 && !video.paused && video.currentTime > 0.05;
      }

      function setFallbackState(enabled) {
        heroWrap.classList.toggle('spclst-video-fallback', !!enabled);
        heroWrap.classList.toggle('spclst-video-ready', !enabled);
        if (posterFallback) {
          posterFallback.setAttribute('aria-hidden', enabled ? 'false' : 'true');
        }
      }

      function scheduleFallbackCheck() {
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        fallbackTimer = window.setTimeout(function () {
          if (isVideoVisiblyPlaying()) {
            setFallbackState(false);
            return;
          }
          setFallbackState(true);
        }, 1200);
      }

      function attemptPlayback() {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            setFallbackState(true);
          });
        }
        scheduleFallbackCheck();
      }

      function syncPlayIcon() {
        if (!playIcon) return;
        var playingSrc = playIcon.getAttribute('data-icon-playing') || playIcon.src;
        var pausedSrc = playIcon.getAttribute('data-icon-paused') || playIcon.src;
        playIcon.src = video.paused ? pausedSrc : playingSrc;
        if (playToggle) {
          playToggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }
      }

      function syncSoundIcon() {
        if (!soundIcon) return;
        var mutedSrc = soundIcon.getAttribute('data-icon-muted') || soundIcon.src;
        var unmutedSrc = soundIcon.getAttribute('data-icon-unmuted') || soundIcon.src;
        soundIcon.src = video.muted ? mutedSrc : unmutedSrc;
        if (soundToggle) {
          soundToggle.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        }
      }

      if (playToggle) {
        playToggle.addEventListener('click', function () {
          if (video.paused) {
            attemptPlayback();
          } else {
            video.pause();
          }
          syncPlayIcon();
          scheduleFallbackCheck();
        });
      }

      if (soundToggle) {
        soundToggle.addEventListener('click', function () {
          video.muted = !video.muted;
          syncSoundIcon();
        });
      }

      video.addEventListener('play', syncPlayIcon);
      video.addEventListener('pause', syncPlayIcon);
      video.addEventListener('playing', function () {
        setFallbackState(false);
      });
      video.addEventListener('timeupdate', function () {
        if (isVideoVisiblyPlaying()) {
          setFallbackState(false);
        }
      });
      video.addEventListener('loadeddata', function () {
        scheduleFallbackCheck();
      });
      video.addEventListener('canplay', function () {
        scheduleFallbackCheck();
      });
      video.addEventListener('stalled', function () {
        setFallbackState(true);
      });
      video.addEventListener('error', function () {
        setFallbackState(true);
      });
      video.addEventListener('abort', function () {
        setFallbackState(true);
      });

      heroWrap.addEventListener(
        'touchstart',
        function () {
          attemptPlayback();
        },
        { passive: true }
      );

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          attemptPlayback();
          scheduleFallbackCheck();
        }
      });

      setFallbackState(true);
      attemptPlayback();
      scheduleFallbackCheck();
      syncPlayIcon();
      syncSoundIcon();
    });

  };
})();
